import { createSlice } from "@reduxjs/toolkit";
import { Get } from "../../config/apiMethod";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loginDetails: null,
  },
  reducers: {
    setLoginDetails: (state, action) => {
      state.loginDetails = action.payload;
    },
  },
});

export const { setLoginDetails } = authSlice.actions;

export const fetchLoginDetails = () => async (dispatch) => {
  
  const token = localStorage.getItem("trelloToken");
  if (token) {
    let response = await Get("user", null, {});
    // console.log("fetchLoginDetails",response);
    
    // if (response.status === 200) {
        // console.log("fetchLoginDetails2",response);

      // localStorage.setItem("userDetails", JSON.stringify(response.data));
      // dispatch(setLoginDetails(response.data));
    // }
  } else {
    dispatch(setLoginDetails(0));
  }
};

export default authSlice.reducer;
